module.exports = __webpack_public_path__ + "img/RIREKI_RANKMARK.5af55864.png";